export enum VehicleDataEnum {

  VEHICLE_TYPE = 'type',
  IS_LEFT_HAND_DRIVE = 'isLeftHandDrive',
  IS_GAS_INSTALLATION = 'isGasInstallation',
  IS_SERVICE_HISTORY = 'isServiceHistory'
}
